import styles from "./setupLayout.module.scss";

export default function SetupLayout({
  step,
  totalSteps,
  title,
  subtitle,
  error,
  onBack,
  backDisabled,
  loading,
  loadingText,
  children,
}) {
  return (
    <div className={styles.page}>
      {loading && (
        <div className={styles.overlay}>
          <div className={styles.spinner} />
          <div className={styles.overlayText}>{loadingText || "Please wait..."}</div>
        </div>
      )}
      <div className={styles.card}>
        <div className={styles.topRow}>
          <span />
          {/* {onBack ? (
            <button
              type="button"
              className={styles.backBtn}
              onClick={onBack}
              disabled={backDisabled}
            >
              &larr; Back
            </button>
          ) : (
            <span />
          )} */}
          <div className={styles.badge}>Setup {step} / {totalSteps}</div>
        </div>
        <h1 className={styles.title}>{title}</h1>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        {error && <div className={styles.error}>{error}</div>}
        <div className={styles.body}>{children}</div>
      </div>
    </div>
  );
}
